<template>
  <div>
    <el-dialog :title=" info.id == null ? '创建合约公司' : '修改合约公司'"
               :visible.sync="dialogVisible"
               width="750px" @close="canceladd">
      <div class="content-wapper"
           v-if="info != null">
        <el-form :model="info"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="150px"
                 style="width:700px;">
          <el-form-item label="合约公司名称"
                        prop="name">
            <el-input placeholder="请输入合约公司名称"
                      v-model="info.name"></el-input>
          </el-form-item>
        
          <el-form-item 
                        label="支持订单类型"
                        prop="availableOrderType"
                        :rules="[
                          { required:($platform =='juyoufuli' && channelCode == 'QD0000'), message: '请输入支持订单类型', trigger: 'submit' },
                        ]">
            <el-select placeholder="请选择支持订单类型"
                     v-model="info.availableOrderType"
                     multiple
                     style="width:100%;">
              <el-option v-for="item in orderTypes"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注说明"
                        prop="remarks">
            <el-input type="textarea"
                      placeholder="请输入发票内容备注信息说明字"
                      rows="5"
                      resize="none"
                      v-model="info.remarks"></el-input>
          </el-form-item>

          <el-form-item label="单张开票额明细"
                        prop="invoiceType">
            <el-table :data="invoiceContentsType">

              <el-table-column prop="type"
                               label="发票类型" width="240px"></el-table-column>
              <el-table-column prop="invoiceAmount"
                               label="单张开票最大额">

                <template slot-scope="scope">
                  <el-input v-model="scope.row.invoiceAmount"
                            type="number"
                            oninput="value=value.replace(/[^0-9.]/g,'')"
                            placeholder="请输入最大额"></el-input>
                </template>

              </el-table-column>
             
            </el-table>
          </el-form-item>

          <el-form-item label="发票内容"
                        v-if= "channelCode == 'QD0000'" 
                        prop="invoiceIds" :rules="[
          { required: isTrue, message: '请选择发票内容', trigger: 'submit' }
        ]">
            <div class="i-content-wapper">
              <div class="i-content-query">
                <el-input placeholder="请输入发票内容名称或关键字"
                          v-model="contentName"
                          style="width:300px;"></el-input>
                <el-button size="small"
                           @click="getInvoiceListByName">查询</el-button>
              </div>
              <el-table :data="invoiceContents"
                        @select="tableSelect"
                        @select-all="tableSelect"
                        :rowKey="getRowKey"
                        ref="invoiceContents">
                <el-table-column type="selection"
                                 width="55" reserve-selection></el-table-column>
                <el-table-column prop="name"
                                 label="发票内容"></el-table-column>
              </el-table>
              <el-pagination
                :page-size="pageParams.pageSize"
                background
                :current-page.sync="pageParams.pageIndex"
                @current-change="handleCurrentChange" 
                layout="prev, pager, next"
                :total="pageParams.total">
              </el-pagination>
            </div>
          </el-form-item>
        </el-form>
        <div class="button-wapper">
          <el-button size="small"
                     @click="canceladd">取消</el-button>
          <el-button size="small"
                     type="primary"
                     @click="submit">确认提交</el-button>
        </div>
      </div>
    </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="secondConfirm"
            width="30%">
            <span>确认提交后，该合约公司将归属于【{{channelName}}】，如果归属有误，请返回合约公司列表，然后点击“切换渠道”按钮切换成功后再创建合约公司，是否确认创建？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="secondConfirm = false">取 消</el-button>
                <el-button type="primary" @click="secondConfirmEven">确 定</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
import _invoiceContent from '@/service/invoice-content-service'
import _invoiceCompany from '@/service/invoice-company-service'
import _purchasePlan from '@/service/purchase-plan-service'
import _channel from '@/service/channel-service'
export default {
  props: {
    channelCode:String,
    channelName:String,
  },
  data () {
    return {
      secondConfirm:false,
      superRole:0,
      channelList:[],
      isTrue:true,
      // 发票内容
      contentName: null,
      invoiceContents: [],
      invoiceContentsType: [
        { type: '增值税普通纸质发票', invoiceAmount: '', radio: '', },
        { type: '增值税专用纸质发票', invoiceAmount: '' , radio: '', },
        { type: '增值税电子普通发票', invoiceAmount: '' , radio: '', },
        { type: '增值税专用电子发票', invoiceAmount: '' , radio: '', },
        { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
        { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
    
      ],
      invoiceContentData:[
        { type: '增值税普通发票', invoiceAmount: '', radio: '', },
        { type: '增值税专用发票', invoiceAmount: '' , radio: '', },
        { type: '增值税电子普通发票', invoiceAmount: '' , radio: '', },
        { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
        { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
      ],
      bodyTypes:null,
      orderTypes:null,
      // 提交信息
      info: {
        id: null,
        name: null,
        invoiceIds: null,
        remarks: null,
        invoiceType: null,
        normalInvoiceAmount: null,//普通发票单张最大额
        specialInvoiceAmount: null,//增值税发票单张最大额
        electronicInvoiceAmount: null,//电子发票单张最大额
        electronicSpecialInvoiceAmount: null,//增值税专用电子发票单张最大额
        vatDigitalElectronNormalInvoiceAmount: null,//增值税数电普通发票最大额（分）
        vatDigitalElectronSpecialInvoiceAmount: null,//	增值税数电专用发票最大额（分）
        bodyType:null,// 主体类型
        normalInvoiceState: null,
        specialInvoiceState: null,
        electronicInvoiceState: null,
        electronicSpecialInvoiceState: null
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { max: 128, message: '公司名称最大128个字符', trigger: 'blur' },
        ],
        /* invoiceIds: [
          { required: true, message: '请选择发票内容', trigger: 'submit' }
        ], */
        invoiceType: [
          { required: true, message: '请输入单张开票额明细', trigger: 'submit' }
        ],

      },
      dialogVisible: false,
      pageParams:{
        total:0,
        pageSize:20,
        pageIndex:1
      }
    }
  },
  watch: {
    channelCode: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal != 'QD0000' ) {
          this.isTrue = false
        }else {
          this.isTrue = true
        }
      },
    },
  },
  created() {
    _channel.getTabPage(res => {
      this.superRole = res.superRole
      this.channelList = res.list
    }) 
  },
  mounted () {
    _purchasePlan.getcategoryList({state:'OrderTypeForContractCompanyEnum'},(res) => {
      if(res){
        this.orderTypes = res
      } else {
        this.orderTypes = []
      }
    })
  },
  methods: {
    // 获取每行的key，是唯一值就行，如果不唯一，一键全选会显示异常
    getRowKey(row) {
          return row.id
    },
    handleCurrentChange (pageIndex) {
      if(pageIndex){
        this.pageParams.pageIndex = pageIndex
      }else {
        this.pageParams.pageIndex = 1
      }
      this.invoiceContents = []
      let _loading = this.$loading({ fullscreen: true })
      _invoiceContent.getInvoiceListByPage({name:this.contentName,...this.pageParams}, (response,total) => {
        this.invoiceContents = response
        this.pageParams.total = total
        setTimeout(() => {
          if(this.info.invoiceIds){
            this.Isselect()
          }
          _loading.close()
        }, 300);
      })
    },
    Isselect() {
      for (const content of this.invoiceContents) {
              var isHave = this.info.invoiceIds.indexOf(content.id)
              if (isHave != -1) {
                this.$refs.invoiceContents.toggleRowSelection(content,true)
              }
            }
    },
    show (id) {
      this.pageParams.pageIndex = 1
      this.getInvoiceListByName(() => {
        if (id != null) {
          let _loading = this.$loading({ fullscreen: true })
            _invoiceCompany.getContractCompanyDetail(id, response => {
            _loading.close()
            this.info = response
              this.invoiceContentsType[0].invoiceAmount = this.$numberUtils.divide(this.info.normalInvoiceAmount, 100)
              this.invoiceContentsType[1].invoiceAmount = this.$numberUtils.divide(this.info.specialInvoiceAmount, 100)
              this.invoiceContentsType[2].invoiceAmount = this.$numberUtils.divide(this.info.electronicInvoiceAmount, 100)
              this.invoiceContentsType[3].invoiceAmount = this.$numberUtils.divide(this.info.electronicSpecialInvoiceAmount, 100)
              this.invoiceContentsType[4].invoiceAmount = this.$numberUtils.divide(this.info.vatDigitalElectronNormalInvoiceAmount, 100)
              this.invoiceContentsType[5].invoiceAmount = this.$numberUtils.divide(this.info.vatDigitalElectronSpecialInvoiceAmount, 100)
  
              this.invoiceContentsType[0].radio = this.info.normalInvoiceState.toString()
              this.invoiceContentsType[1].radio = this.info.specialInvoiceState.toString()
              this.invoiceContentsType[2].radio = this.info.electronicInvoiceState.toString()
              this.invoiceContentsType[3].radio = this.info.electronicSpecialInvoiceState.toString()
              this.invoiceContentsType[4].radio = this.info.vatDigitalElectronNormalInvoiceState.toString()
              this.invoiceContentsType[5].radio = this.info.vatDigitalElectronSpecialInvoiceState.toString()
             
            // 选中已选
            this.Isselect()
          }, response => {
            _loading.close()
            this.$notify({
              message: response,
              type: 'warning'
            })
          })
          
    
        } else {
          this.info = {
            id: null,
            name: null,
            invoiceIds: null,
            remarks: null,
            normalInvoiceAmount: null,//普通发票单张最大额
            specialInvoiceAmount: null,//增值税发票单张最大额
            electronicInvoiceAmount: null,//电子发票单张最大额
            electronicSpecialInvoiceAmount: null, //增值税专用电子发票单张最大额	
            vatDigitalElectronNormalInvoiceAmount: null,//增值税数电普通发票最大额（分）
            vatDigitalElectronSpecialInvoiceAmount: null,//	增值税数电专用发票最大额（分）
            normalInvoiceState: null,
            specialInvoiceState: null,
            electronicInvoiceState: null,
            electronicSpecialInvoiceState: null
          }
          this.invoiceContentsType = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用电子发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:'1'},
        
          ]
          this.invoiceContentData = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:''},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
          ]
          this.$refs.invoiceContents.clearSelection()
        }
      })
      this.dialogVisible = true
    },
    // 发票内容查询
    getInvoiceListByName (callBack) {
      this.invoiceContents = []
      _invoiceContent.getInvoiceListByPage({name:this.contentName,...this.pageParams}, (response, total) => {
        this.invoiceContents = response
        this.pageParams.total = total
        callBack()
      })
    },
    // 表格多选事件
    tableSelect (selection) {
      this.info.invoiceIds = []
      selection.forEach(item => {
        this.info.invoiceIds.push(item.id)
      })
    },
    secondConfirmEven() {
      this.info.channelCode = this.channelCode
        // 提交请求
        let _loading = this.$loading({ fullscreen: true })
        _invoiceCompany.addOrUpdateContractCompany(this.info, () => {
          _loading.close()
          this.secondConfirm = false
          this.$notify({
            message: this.info.id == null ? '添加成功' : '修改成功',
            type: 'success'
          });
          this.invoiceContentsType = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用电子发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:'1'},
         
          ]
          this.invoiceContentData = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:''},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
          ]
          this.contentName = null
          this.dialogVisible = false
          this.$emit('refresh')
        }, response => {
          _loading.close()
          this.$notify({
            message: response,
            type: 'warning'
          })
          this.secondConfirm = false
        })
    },
    // 提交
    submit () {
      const test = /^[0-9]\d*$/
      if(this.$platform == 'juyoufuli') {
        this.info.normalInvoiceAmount = test.test(this.invoiceContentsType[0].invoiceAmount)?Number(this.invoiceContentsType[0].invoiceAmount):''
        this.info.specialInvoiceAmount = test.test(this.invoiceContentsType[1].invoiceAmount)?Number(this.invoiceContentsType[1].invoiceAmount):''
        this.info.electronicInvoiceAmount = test.test(this.invoiceContentsType[2].invoiceAmount)?Number(this.invoiceContentsType[2].invoiceAmount):''
        this.info.electronicSpecialInvoiceAmount = test.test(this.invoiceContentsType[3].invoiceAmount)?Number(this.invoiceContentsType[3].invoiceAmount):''
        this.info.vatDigitalElectronNormalInvoiceAmount = test.test(this.invoiceContentsType[4].invoiceAmount)?Number(this.invoiceContentsType[4].invoiceAmount):''
        this.info.vatDigitalElectronSpecialInvoiceAmount = test.test(this.invoiceContentsType[5].invoiceAmount)?Number(this.invoiceContentsType[5].invoiceAmount):''
        this.info.normalInvoiceState = this.invoiceContentsType[0].radio
        this.info.specialInvoiceState = this.invoiceContentsType[1].radio
        this.info.electronicInvoiceState = this.invoiceContentsType[2].radio
        this.info.electronicSpecialInvoiceState = this.invoiceContentsType[3].radio
        this.info.vatDigitalElectronNormalInvoiceState = this.invoiceContentsType[4].radio
        this.info.vatDigitalElectronSpecialInvoiceState = this.invoiceContentsType[5].radio
      }
      const {normalInvoiceAmount,specialInvoiceAmount,electronicInvoiceAmount,electronicSpecialInvoiceAmount,vatDigitalElectronNormalInvoiceAmount,vatDigitalElectronSpecialInvoiceAmount} = this.info
      if (this.$platform == 'juyoufuli' && test.test(normalInvoiceAmount) && test.test(specialInvoiceAmount) && test.test(electronicInvoiceAmount) && test.test(electronicSpecialInvoiceAmount)&& test.test(vatDigitalElectronNormalInvoiceAmount)&& test.test(vatDigitalElectronSpecialInvoiceAmount)) {
        this.$set(this.info, 'invoiceType', 1)
      }else {
        this.$set(this.info, 'invoiceType', null)
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false
        }
        if(this.superRole == 3) {
          this.secondConfirm = true
          return
        }
        // 提交请求
        let _loading = this.$loading({ fullscreen: true })
        _invoiceCompany.addOrUpdateContractCompany(this.info, () => {
          _loading.close()
          this.$notify({
            message: this.info.id == null ? '添加成功' : '修改成功',
            type: 'success'
          });
          this.invoiceContentsType = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税专用电子发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:'1'},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:'1'},
       
          ]
          this.invoiceContentData = [
            { type: '增值税普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税专用发票', invoiceAmount: '' ,radio:''},
            { type: '增值税电子普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
            { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
          ]
          this.contentName = null
          this.dialogVisible = false
          this.$emit('refresh')
        }, response => {
          _loading.close()
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
      })
    },

    canceladd() {
      this.invoiceContentsType = [
        { type: '增值税普通发票', invoiceAmount: '' ,radio:'1'},
        { type: '增值税专用发票', invoiceAmount: '' ,radio:'1'},
        { type: '增值税电子普通发票', invoiceAmount: '' ,radio:'1'},
        { type: '增值税专用电子发票', invoiceAmount: '' ,radio:'1'},
        { type: '增值税数电普通发票', invoiceAmount: '' ,radio:'1'},
        { type: '增值税数电专用发票', invoiceAmount: '' ,radio:'1'},
     
      ]
      this.invoiceContentData = [
        { type: '增值税普通发票', invoiceAmount: '' ,radio:''},
        { type: '增值税专用发票', invoiceAmount: '' ,radio:''},
        { type: '增值税电子普通发票', invoiceAmount: '' ,radio:''},
        { type: '增值税数电普通发票', invoiceAmount: '' ,radio:''},
        { type: '增值税数电专用发票', invoiceAmount: '' ,radio:''},
      ]
      this.contentName = null
      this.$refs.ruleForm.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.content-wapper {
  margin-bottom: 30px;
}
.button-wapper {
  margin-left: 150px;
}
.button-wapper .el-button {
  width: 150px;
}
.info-wapper {
  font-size: 12px;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper div {
  display: inline-block;
  position: relative;
}
.info-wapper span {
  margin-left: 160px;
}
.info-wapper label {
  color: #606266;
  display: inline-block;
  width: 150px;
  text-align: right;
  position: absolute;
  top: -2px;
  padding-right: 12px;
}
.i-content-query {
  border: 1px solid #d6dbe5;
  border-bottom: none;
  padding: 15px;
}
.i-content-query .el-input {
  margin-right: 15px;
}
</style>import { response } from 'express'
